import type { RefObject } from 'react'

import { InfiniteStatusEnum } from '../../../repository/infinite'
import { useInfiniteInsightsCarousel } from '../hooks/useInfiniteInsightsCarousel'
import { InfiniteInsightItem } from '../types/infiniteLanding.types'

export const InfiniteLandingInsights = ({ onboardingStatus }: { onboardingStatus?: InfiniteStatusEnum }) => {
  const { scrollRef, carouselItems, onCarouselScroll } = useInfiniteInsightsCarousel()

  return (
    <div className='relative bg-black text-center'>
      <div className='relative bg-white pt-12 pb-[72px]'>
        {onboardingStatus !== InfiniteStatusEnum.ELIGIBLE ? (
          <>
            <p className='text-center font-libre-caslon text-[18px] leading-[1.2] tracking-[-0.18px] text-black'>Infinite, at a glance</p>
            <div className='mt-8 flex justify-center'>
              <svg xmlns="http://www.w3.org/2000/svg" width="402" height="2" viewBox="0 0 402 2" fill="none">
                <path d="M0 0.800049H401.878" stroke="url(#paint0_radial_243_763)" stroke-width="1.6" />
                <defs>
                  <radialGradient id="paint0_radial_243_763" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(200.939 -6.08481) rotate(90) scale(170.671 170.671)">
                    <stop stop-color="#2888EF" />
                    <stop offset="0.4375" stop-color="#28B3EF" stop-opacity="0.5625" />
                    <stop offset="1" stop-color="#2888EF" stop-opacity="0" />
                  </radialGradient>
                </defs>
              </svg>
            </div>
          </>
        ) : null}
        <p className='mx-auto mt-6 w-[314px] font-libre-caslon text-[24px] leading-[1.34] tracking-[-0.48px] text-black'>
          As wealth grows, so does the complexity of decisions.
        </p>
        <div
          ref={scrollRef as RefObject<HTMLDivElement>}
          className='mt-12 overflow-x-auto no-scrollbar snap-x snap-mandatory'
          onScroll={onCarouselScroll}
        >
          <div className='flex w-max items-center gap-4'>
            <div className='w-[calc(50vw-105px)] shrink-0' />
            {carouselItems.map((item, index) => (
              <div key={`${item.title}-${index}`} className='shrink-0 snap-center'>
                <InfiniteLandingInsightCarouselCard item={item} isCenter={index === 0} />
              </div>
            ))}
            <div className='w-[calc(50vw-105px)] shrink-0' />
          </div>
        </div>
      </div>
    </div>
  )
}

export function InfiniteLandingInsightCarouselCard({
  item,
  isCenter
}: {
  item: InfiniteInsightItem
  isCenter: boolean
}) {
  return (
    <div
      className={'h-[280px] w-[210px] rounded-2xl border border-[rgba(103,103,103,0.15)] px-6 pt-10'}
    >
      <img src={item.icon} alt={item.title} className={`mx-auto object-contain ${isCenter ? 'h-[106px] w-[103px]' : 'h-[95px] w-[92px]'}`} />
      <p className={`mt-4 font-libre-franklin font-medium leading-[1.34] tracking-[-0.24px] ${item.titleClassName}`}>{item.title}</p>
      <p className='mt-3 font-libre-franklin text-[12px] leading-[1.34] tracking-[-0.12px] text-[#727272]'>{item.description}</p>
    </div>
  )
}
